import React from 'react'
// import { Button } from "@material-tailwind/react";

export default function Btn({children}) {
  return (
    <div className="flex w-max gap-4">
      <button >{children}</button>
    </div>
  );
}